import notificationTypes from '../../config/notificationTypes'
import ClientNotificationInterface from '../../interfaces/client/Notification'
import generateUniqueId from '../generateUniqueId'

const defaultType = notificationTypes.error
const buildGenericNotification = (
  message: string,
  type?: string
): ClientNotificationInterface => {
  return {
    id: generateUniqueId(),
    type: type || defaultType,
    message,
    code: `[${message}]`,
    isGlobal: true,
  }
}

export default buildGenericNotification
